import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../constants/request'
import {
  EmailDraftCreateActionSelectModal,
  useEmailCreationFormInitialValues,
  useEmailDraft,
  useEmailGetActiveAccountForCreate,
} from '../../../../Email'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import {
  EMAIL_AUDIENCE_BY_RECIPIENT_TYPE,
  EMAIL_RECIPIENT_TYPE_PROVIDERS,
  getToRecipients,
  RequestProfileTabEmailsCreateEmailPopUp,
} from '../../../RequestProfileTabEmails'

export function useRequestProfileCreateEmailAction() {
  const {
    handleCloseModal,
    handleReloadAfterChange,
    requestContractors,
    requestData,
    setModal,
  } = useRequestProfileContext()

  const { activeAccountForCreate } = useEmailGetActiveAccountForCreate({
    withServiceAccount: true,
  })

  const emailInitial = useEmailCreationFormInitialValues({
    account: activeAccountForCreate,
  })

  const { draft: emailDraft } = useEmailDraft()

  async function handleReloadAfterSend() {
    return handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.emails)
  }

  function handleOpenEmailCreatePopUp({ audience, initialValues }) {
    setModal(
      <RequestProfileTabEmailsCreateEmailPopUp
        audience={audience}
        initialValues={initialValues}
        requestData={requestData}
        requestId={requestData?.id}
        onClose={handleCloseModal}
        onSendSuccess={handleReloadAfterSend}
      />
    )
  }

  function handleSelectAudience({ recipientType }) {
    const audience = EMAIL_AUDIENCE_BY_RECIPIENT_TYPE[recipientType]

    const initialValues = {
      ...emailInitial,
      to: getToRecipients({
        recipientType,
        requestContractors,
        requestData,
      }),
    }

    if (emailDraft) {
      setModal(
        <EmailDraftCreateActionSelectModal
          draft={emailDraft}
          initialValues={initialValues}
          onCancel={handleCloseModal}
          onSubmit={({ initialValues: nextInitialValues }) =>
            handleOpenEmailCreatePopUp({
              audience,
              initialValues: nextInitialValues,
            })
          }
        />
      )

      return
    }

    handleOpenEmailCreatePopUp({ audience, initialValues })
  }

  function handleSelectEmailAudience({ value }) {
    return handleSelectAudience({ recipientType: value })
  }

  function handleClickCreateEmail() {
    return handleSelectAudience({
      recipientType: EMAIL_RECIPIENT_TYPE_PROVIDERS,
    })
  }

  return {
    handleClickCreateEmail,
    handleSelectEmailAudience,
  }
}
